import { z } from "zod";

export const emailConfirmSchema = z.object({
  userName: z.string().optional(),
  code: z.string().nonempty("page.confirm_email.error.code"),
});

export type TEmailConfirm = z.infer<typeof emailConfirmSchema>;
